import React from "react";
import styles from "./styles";
import { LogoGroup } from "../../../../../Diathrive/src/utils/SvgIcons";

const LogoHeader = (props) => (
  <LogoGroup width={146} height={40} style={styles.logo} {...props} />
);

export default LogoHeader;
